import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card, Overline, Pill, Icon, PageLoader, EmptyState } from "../../components/ui-kit";
import { cn } from "../../lib/utils";

const diffTone = { easy: "green", medium: "yellow", hard: "coral" };

export default function QuestionBank() {
  const [questions, setQuestions] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [filter, setFilter] = useState({ subject_id: "", difficulty: "" });

  useEffect(() => { api.get("/academics/subjects").then(({ data }) => setSubjects(data)); }, []);
  useEffect(() => {
    const p = new URLSearchParams();
    if (filter.subject_id) p.set("subject_id", filter.subject_id);
    if (filter.difficulty) p.set("difficulty", filter.difficulty);
    api.get(`/teacher/question-bank?${p}`).then(({ data }) => setQuestions(data));
  }, [filter]);
  if (!questions) return <PageLoader />;

  const sel = "px-3.5 py-2.5 rounded-xl border border-mim-line text-sm bg-white outline-none focus:border-mim-blue";
  return (
    <div className="max-w-5xl mx-auto p-4 sm:p-6">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <div><Overline>Central Repository</Overline><h1 className="text-2xl font-bold text-mim-navy mt-1">Question Bank</h1></div>
        <div className="flex gap-2">
          <select className={sel} value={filter.subject_id} onChange={(e) => setFilter({ ...filter, subject_id: e.target.value })} data-testid="qb-subject">
            <option value="">All subjects</option>{subjects.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <select className={sel} value={filter.difficulty} onChange={(e) => setFilter({ ...filter, difficulty: e.target.value })} data-testid="qb-difficulty">
            <option value="">All levels</option><option>easy</option><option>medium</option><option>hard</option>
          </select>
        </div>
      </div>
      <p className="text-sm text-mim-muted mb-4">{questions.length} approved questions</p>
      {questions.length === 0 ? <Card><EmptyState icon="Database" title="No questions found" subtitle="Adjust filters or generate new ones in AI Studio." /></Card> : (
        <div className="space-y-3">
          {questions.map((q, i) => (
            <Card key={q.id} className="animate-fade-up">
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-lg bg-mim-soft text-mim-blue text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">{i + 1}</span>
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <Pill tone={diffTone[q.difficulty]}>{q.difficulty}</Pill>
                    <Pill tone="blue">{q.type}</Pill>
                    <Pill tone="green" icon="Check">approved</Pill>
                  </div>
                  <p className="font-semibold text-mim-navy text-sm">{q.question}</p>
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    {q.options.map((o) => <span key={o} className={cn("text-xs px-2.5 py-1 rounded-lg border", o === q.answer ? "border-mim-green bg-mim-green/10 text-mim-green font-semibold" : "border-mim-line text-mim-muted")}>{o}</span>)}
                  </div>
                  <p className="text-xs text-mim-muted mt-2"><span className="font-semibold">Explanation: </span>{q.explanation}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
